(() => {
  function init(root) {
    if (!root || root.dataset.saleReady) return;
    const selector = root.querySelector('evolene-bundle-selector');
    if (!selector) return;
    customElements.whenDefined('evolene-bundle-selector').then(() => {
      if (!root.isConnected) return;
      customElements.upgrade(selector);
      root.dataset.saleReady = 'true';
      const set = (key, value) => { root.querySelector(`[data-sale-${key}]`).textContent = value; };
      function update() {
        const choice = selector.selection();
        set('selected', `${choice.quantity} bottle${choice.quantity > 1 ? 's' : ''}`);
        selector.querySelector('[data-ev-status]').textContent = '';
      }
      selector.addEventListener('change', update);
      update();
    });
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href="#buy"]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const offer = root.querySelector('.sale-buy-panel');
      if (!offer) return;
      event.preventDefault();
      if (window.location.hash !== '#buy') history.pushState(null, '', '#buy');
      window.scrollTo({
        top: window.scrollY + offer.getBoundingClientRect().top - 16,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
    const track = root.querySelector('[data-sale-gallery-track]');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = 'true';
    const slides = Array.from(track.children);
    const thumbs = Array.from(root.querySelectorAll('[data-sale-gallery-index]'));
    const prev = root.querySelector('[data-sale-gallery-prev]');
    const next = root.querySelector('[data-sale-gallery-next]');
    let index = 0;
    function refresh() {
      index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((button, i) => i === index ? button.setAttribute('aria-current','true') : button.removeAttribute('aria-current'));
      root.querySelector('[data-sale-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    }
    function go(i) {
      track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, i)) * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    thumbs.forEach((button, i) => button.addEventListener('click', () => go(i)));
    prev.addEventListener('click', () => go(index - 1));
    next.addEventListener('click', () => go(index + 1));
    track.addEventListener('scroll', refresh, {passive:true});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    new ResizeObserver(refresh).observe(track);
    refresh();
  }
  init(document.getElementById('EvSale'));
  document.addEventListener('shopify:section:load', () => init(document.getElementById('EvSale')));
})();
